import { API, TOKEN_KEY, baseURL, getSECURE_API, sendFormDataRequest } from 'api';
import axios from 'axios';

const SECURE_API = getSECURE_API();


export const getUserTickets = (id) => SECURE_API.get(`/game-tickets/user/${id}`);


SECURE_API.interceptors.request.use((req) => {
  req.baseURL = `${req.baseURL}/users`;
  return req;
});

// API.interceptors.request.use((req) => {
//   req.baseURL = `${req.baseURL}/users`;
//   return req;
// });

export const getAll = () => SECURE_API.get('/');
export const getMe = () => SECURE_API.get('/me');
export const getMyBookings = () => SECURE_API.get('/bookings');
export const banAgent = (id, body) => SECURE_API.put(`/${id}`, body);

export const updateMe = (profile, dontUseFormData = false) =>
  dontUseFormData ? SECURE_API.put('/me', profile) : sendFormDataRequest('users/me', 'PUT', profile, 'image');

export const updateUserPassword = (id, body) =>
  axios.put(
    `${baseURL}/users/${id}/password`,
    {
      ...body,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
      },
    },
  );

export const updatePassword = (body) =>
  axios.put(
    `${baseURL}/auth/update-password`,
    {
      ...body,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
      },
    },
  );

export const createOne = (userInfo) =>
  SECURE_API.post('/', {
    ...userInfo,
  });

export const updateOne = ({ id, updatedUser }) =>
  SECURE_API.put(`/${id}`, {
    ...updatedUser,
  });
export const deleteOne = (id) => SECURE_API.delete(`/${id}`);

export const logIn = (values) => API.post('/auth/login', values);
export const signUp = (values) => sendFormDataRequest('/auth/signup', 'POST', values, 'image');

export const forgotPassword = (values) => API.post('/auth/forgotPassword', values);

export const resetPassword = (token, values) => API.put(`/auth/resetPassword/${token}`, values);

export const confirmMail = (token) => API.get(`/auth/confirmMail/${token}`);

const AG_SECURE_API = getSECURE_API();
export const getAllUsers = () => AG_SECURE_API.get(`/users/all`);


export const getUsersByReferral = () => AG_SECURE_API.get(`/links/users`);

export const getUserPlatforms = (id) => AG_SECURE_API.get(`/user-games/${id}`);

export const getTransactionsByUser = (id) => AG_SECURE_API.get(`/funds/get-transaction-by-agent/${id}`);

export const getUserDetails = (id) => SECURE_API.get(`/get-user-info/${id}`);

export const rechargeByAdmin = (payload) => AG_SECURE_API.post("/games/recharge-by-admin", payload)

export const redeemByAdmin = (payload) => AG_SECURE_API.post("/games/redeem-by-admin", payload)

export const refreshByAdmin = (payload) => AG_SECURE_API.post("/games/refresh-by-admin", payload)